import { jobsite } from './builder';
import { OneClickConfig } from '../../../../models/one-click-config';
import { ShippingLocationModeCode } from '../../../../models/shipping-location-mode.model';
import { preview } from './preview';

export const ownFreight: OneClickConfig = {
  preview: preview,
  builder: {
    [ShippingLocationModeCode.Jobsite]: jobsite,
  },
};
